
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lend",
      function () {
        return require("private-next-pages/lend/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lend"])
      });
    }
  